import { render, staticRenderFns } from "./editOrderDialog.vue?vue&type=template&id=529e70aa&"
import script from "./editOrderDialog.vue?vue&type=script&lang=js&"
export * from "./editOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports